import { demoFile, feature } from 'system/demo';
import { PushNotificationPopupFeature } from '../push-notification-popup-settings';
import { SimpleCommentsStructure } from 'structure/simple-comments';

demoFile('open-modules/zdf/feature/pushNotifications/push-notification-popup-settings');

feature('Push Notification Popup', {
    structureKey: 'simplecomments',
    config: SimpleCommentsStructure.receivesConfigDefaults,
    state: { sessionData: { requestNotificationPermission: { value: true } } },
    features: { pushnotificationspopup: true }
});
